var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "tree-box" },
    [
      _c(
        "el-select",
        {
          ref: "treeSelect",
          staticStyle: { width: "100%" },
          attrs: {
            clearable: true,
            placeholder: _vm.placeholder,
            multiple: _vm.multiple,
            filterable: "",
            "filter-method": _vm.filterable,
          },
          on: { clear: _vm.handleClear, "remove-tag": _vm.handleRemoveTag },
          model: {
            value: _vm.valueLabel,
            callback: function ($$v) {
              _vm.valueLabel = $$v
            },
            expression: "valueLabel",
          },
        },
        [
          _c("el-option", {
            attrs: { hidden: "", value: "value", label: "label" },
          }),
          _vm._v(" "),
          _c("el-tree", {
            ref: "treeSelectTree",
            attrs: {
              accordion: true,
              data: _vm.treeData,
              props: _vm.props,
              "node-key": _vm.props.value,
              "highlight-current": !_vm.multiple,
              "show-checkbox": _vm.multiple,
              "check-strictly": true,
              load: _vm.loadNode,
              lazy: true,
              "filter-node-method": _vm.filterNode,
            },
            on: {
              "node-click": _vm.handleNodeClick,
              check: _vm.handleNodeCheckbox,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }